module.exports = __webpack_public_path__ + "static/img/case_detail_13_2.6ff5ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_13_2.png
// module id = 22u+
// module chunks = 34